<template>
  <div class="u-section-padding">
    <div class="l-wrap">
      <!-- BACK HOME -->
      <router-link :to="{ name: 'Home' }" class="u-mb-20 u-text-underline"
        >Back home</router-link
      >

      <!-- Web development 101 -->
      <div class="c-table-responsive">
        <table class="c-table">
          <caption>
            Web development 101
          </caption>
          <tbody>
            <tr>
              <td>
                <a
                  href="https://web.stanford.edu/class/msande91si/www-spr04/readings/week1/InternetWhitepaper.htm"
                  target="_blank"
                  >How Does the Internet Work?</a
                >
                [<strong>Stanford University</strong>]
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://public-archive.web.cern.ch/en/About/WebWork-en.html  "
                  target="_blank"
                  >How the web works</a
                >
                [<strong>CERN</strong>]
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://www.thinkful.com/blog/web-developer-cheat-sheet/"
                  target="_blank"
                  >The Ultimate Cheat Sheet for Web Developers</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://www.thinkful.com/blog/why-learning-to-code-is-so-damn-hard/"
                  target="_blank"
                  >Why Learning to Code is So Damn Hard</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://learn.co/lessons/how-the-web-works-readme"
                  target="_blank"
                  >How The Web Works Readme</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://www.explainthatstuff.com/howthewebworks.html"
                  target="_blank"
                  >How the World Wide Web (WWW) works</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://www.vikingcodeschool.com/dashboard#/web-development-basics/how-the-web-works"
                  target="_blank"
                  >How the Web Works</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://hostingfacts.com/web-development-101/"
                  target="_blank"
                  >Web Development &amp; Design 101</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://service.uoregon.edu/TDClient/2030/Portal/KB/ArticleDet?ID=31787"
                  target="_blank"
                  >How To Diagnose Internet Connectivity Problems</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="http://www.steves-internet-guide.com/binary-numbers-explained/"
                  target="_blank"
                  >Binary Numbers Explained – Beginners Guide</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://homepage.cs.uri.edu/faculty/wolfe/book/Readings/Reading04.htm"
                  target="_blank"
                  >How Computers Work: The CPU and Memory</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://thehistoryoftheweb.com/timeline/"
                  target="_blank"
                  >The History of the Web</a
                >
              </td>
            </tr>
            <tr>
              <td>
                <a
                  href="https://academind.com/learn/web-dev/web-development-overview/"
                  target="_blank"
                  >A Complete Web Development Learning Path</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /.c-table-responsive -->
    </div>
    <!-- /.l-wrap -->
  </div>
</template>

<script>
export default {
  name: "WebDevelopment",
};
</script>